import Alert from 'components/new-ui/base/alert/Alert';

const formatter = new Intl.NumberFormat('en-EU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: false,
});

type Props = {
    amountPaid: number | null;
    totalAmount: number | null;
    currencySymbol: string;
};

const PartiallyPaidAlert = ({ amountPaid, totalAmount, currencySymbol }: Props) => {
    const defaultMessage = 'Missing amounts data. Please contact our support team for assistance.';

    if (amountPaid === null || totalAmount === null) {
        return <Alert showIcon type="error" message={defaultMessage} />;
    }

    const formattedAmountPaid = formatter.format(amountPaid);
    const formattedTotalAmount = formatter.format(totalAmount);

    return (
        <Alert
            showIcon
            type="warning"
            message={
                <>
                    Invoice has been marked as partially paid. Amount:{' '}
                    <strong>
                        ({currencySymbol}) {formattedAmountPaid} / ({currencySymbol}) {formattedTotalAmount}
                    </strong>
                </>
            }
        />
    );
};

export default PartiallyPaidAlert;
